import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import womBasketServices from './womBasket.services';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { AxiosError } from 'axios';
import { WomBasketListRequest } from './womBasket.types';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { WORKORDER_COMPLEMENT_DETAIL_KEY } from '../../workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';

const WOM_BASKET_DETAIL = 'wom/basket/detail';

export function useWomBasketCreate() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: womBasketServices.createBasket,
    onSuccess(_, vars) {
      notification.success({ message: 'Cesta criada com sucesso' });
      queryChanel({
        invalidateQueries: [
          [
            WOM_BASKET_DETAIL,
            { workOrderComplementId: vars.workOrderComplementId },
          ],
        ],
        refetchQueries: [
          [WORKORDER_COMPLEMENT_DETAIL_KEY, vars.workOrderComplementId],
        ],
      });
    },
    onError(err) {
      notificationError(err);
    },
  });
}

export function useWomBasketDetail(
  workOrderComplementId?: number,
  enabled = true,
) {
  return useQuery({
    queryKey: [WOM_BASKET_DETAIL, { workOrderComplementId }],
    queryFn: () => womBasketServices.detailBasket(workOrderComplementId),
    enabled: !!workOrderComplementId && enabled,
  });
}

export function useWomBasketList(
  params?: WomBasketListRequest,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: [WOM_BASKET_DETAIL, { params }],
    queryFn: ({ pageParam }) =>
      womBasketServices.listBasket({ ...params, nextToken: pageParam }),
    enabled: !!params && enabled,
    getNextPageParam: (lastPage) => lastPage.nextToken,
    onError(err: AxiosError) {
      if (err?.response?.status !== 404) {
        notificationError(err);
      }
    },
  });
}

export function useWomBasketDelete() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: womBasketServices.deleteBasket,
    onSuccess(_, vars) {
      notification.success({ message: 'Cesta excluída com sucesso' });
      queryChanel({
        invalidateQueries: [
          [WOM_BASKET_DETAIL, { workOrderComplementId: vars }],
        ],
        removeQueries: [[WOM_BASKET_DETAIL, { workOrderComplementId: vars }]],
        refetchQueries: [
          ['workOrders'],
          [WORKORDER_COMPLEMENT_DETAIL_KEY, vars],
        ],
      });
    },
    onError(err) {
      notificationError(err);
    },
  });
}
